"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _styles = require("@material-ui/core/styles");

var _omit = _interopRequireDefault(require("lodash/omit"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  return {
    pageLoader: {
      textAlign: 'center',
      padding: theme.spacing(4, 0)
    },
    centeredLoader: {
      textAlign: 'center'
    }
  };
};

var CustomCircularLoader = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(CustomCircularLoader, _PureComponent);

  function CustomCircularLoader() {
    (0, _classCallCheck2["default"])(this, CustomCircularLoader);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CustomCircularLoader).apply(this, arguments));
  }

  (0, _createClass2["default"])(CustomCircularLoader, [{
    key: "render",
    value: function render() {
      var centered = this.props.centered;
      var withPadding = this.props.withPadding;
      var props = (0, _omit["default"])(this.props, 'centered', 'withPadding');

      if (centered || withPadding) {
        var classNames = [];

        if (centered) {
          classNames = classNames.concat(this.props.classes.centeredLoader);
        }

        if (withPadding) {
          classNames = classNames.concat(this.props.classes.pageLoader);
        }

        return _react["default"].createElement("div", {
          className: classNames.join(' ')
        }, _react["default"].createElement(_CircularProgress["default"], (0, _extends2["default"])({}, props, {
          classes: _objectSpread({}, (0, _omit["default"])(this.props.classes, 'pageLoader', 'centeredLoader'))
        })));
      }

      return _react["default"].createElement(_CircularProgress["default"], (0, _extends2["default"])({}, props, {
        classes: _objectSpread({}, (0, _omit["default"])(this.props.classes, 'pageLoader', 'centeredLoader'))
      }));
    }
  }]);
  return CustomCircularLoader;
}(_react.PureComponent);

CustomCircularLoader.propTypes = {
  centered: _propTypes["default"].bool,
  withPadding: _propTypes["default"].bool,
  classes: _propTypes["default"].object.isRequired
};
CustomCircularLoader.defaultProps = {
  centered: false,
  withPadding: false
};
var CustomCircularLoaderStyled = (0, _styles.withStyles)(styles)(CustomCircularLoader);
var _default = CustomCircularLoaderStyled;
exports["default"] = _default;